export type ProductInfo = {
  selections: Record<string, string> | undefined;
  version: number;
  coreProductId: string;
  mpvId: string;
};

export enum PriceDisplayGroup {
  FROM = "FROM",
  EACH = "EACH",
  RANGED = "RANGED",
}
